// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__FrZOV","circle":"styles_circle__Zp4Zf","sharp":"styles_sharp__qeO1i","avatar_image":"styles_avatar_image__SJd8v"};